import styled from "styled-components";

// Spacer component
const Spacer = styled.div`
  height: ${({ height }) => height || "16px"};
`;

export default Spacer;
